import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorShippingHeaderSearch = () => {
  const shippingHeaderSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/transaction-shipping-header/search', payload, (response) => {
      if (response.status_code === 200) {
        if (response.data) {
          callback(response.data)
        } else {
          callback(null)
        }
      }
      loading(false)
    })
  }, [])

  return { shippingHeaderSearch }
}

export default InteractorShippingHeaderSearch
